// extracted by mini-css-extract-plugin
module.exports = {"view":"view_view__1m6FS","title":"view_title__22CEh"};